import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { HEADER_ID, PageLayout } from '@/components/templates/PageLayout';
import {
  CmButton,
  CmLongLoading,
  CmScrollBox,
  CmStack,
} from '@/components/uiParts';
import { CmBackLink } from '@/components/uiParts/Link/CmBackLink ';
import { useTargetsDomHeight } from '@/hooks/Dom';
import { redirect404Page } from '@/lib/AccessControl';
import { TempHourForm } from '@/pages/camel-order/temp-hour/components/TempHourForm';
import { useTempHourForm } from '@/pages/camel-order/temp-hour/hooks/useTempHoursForm';
import { routes } from '@/router';
import { useManagerAccountMe } from '@/services/AuthEnterprise/hooks';

export const BREAD_CRUMB_AREA_ID = 'bread-crumb-area';

const TempHoursNewPage: React.FC = (): JSX.Element => {
  // /* アクセス制御 */
  const history = useHistory();
  const { managerAccountMe } = useManagerAccountMe();
  redirect404Page('camel_order_site_setting', history, managerAccountMe);

  const { targetsHeight } = useTargetsDomHeight([
    HEADER_ID,
    BREAD_CRUMB_AREA_ID,
  ]);

  const {
    isLoading,
    initialize,
    handleCreate,
    selectedSiteId,
    isDisabledSubmit,
    listUrl,
    ...formProps
  } = useTempHourForm();

  useEffect(() => {
    (async () => {
      initialize();
    })();
  }, []);

  return (
    <PageLayout title={routes.tempHourNew.title}>
      <CmStack
        direction="row"
        mt="25px"
        id={BREAD_CRUMB_AREA_ID}
        justifyContent="space-between"
        alignItems="center"
      >
        <CmBackLink to={listUrl}>一覧へ戻る</CmBackLink>
        {/*
         // @ts-ignore TS2590 */}
        <CmButton isDisabled={isDisabledSubmit} onClick={handleCreate}>
          新規
        </CmButton>
      </CmStack>
      <CmScrollBox>
        <TempHourForm
          {...formProps}
          selectedSiteId={selectedSiteId}
          height={`calc(100vh - ${targetsHeight}px - 80px)`}
        />
      </CmScrollBox>
      {isLoading && <CmLongLoading />}
    </PageLayout>
  );
};

export default TempHoursNewPage;
